<template>
  <div
    v-if="image"
    class="lightbox"
    @click="$emit('close')"
  >
    <button
      type="button"
      class="lightbox-close"
      aria-label="Close image"
      @click="$emit('close')"
    >&times;</button>
    <img
      class="lightbox-img"
      :src="image.src"
      :alt="image.alt"
      @click.stop
    />
  </div>
</template>

<script>
export default {
  name: 'lightbox',
  props: {
    image: {
      type: Object,
      default: null
    }
  },
  watch: {
    image (value) {
      if (value) {
        document.addEventListener('keydown', this.onKeydown)
        document.body.style.overflow = 'hidden'
      } else {
        this.cleanup()
      }
    }
  },
  methods: {
    onKeydown (e) {
      if (e.key === 'Escape') {
        this.$emit('close')
      }
    },
    cleanup () {
      document.removeEventListener('keydown', this.onKeydown)
      document.body.style.overflow = ''
    }
  },
  beforeDestroy () {
    this.cleanup()
  }
}
</script>

<style lang="scss" scoped>
.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;

  background: rgba(0, 0, 0, 0.85);
  cursor: zoom-out;
}

.lightbox-img {
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
  cursor: default;
}

.lightbox-close {
  position: absolute;
  top: 1rem;
  right: 1.5rem;

  padding: 0;
  border: none;
  background: none;

  color: #fff;
  font-size: 3rem;
  line-height: 1;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/Lightbox.vue